import React from 'react';
import classNames from 'classnames';

import './divider.scss';

const Divider: React.FC<{ className?: string; vertical?: boolean; }> = ({ className, vertical }) => {
    const classes = classNames({
        'divider': true,
        'divider--vertical': vertical
    });

    return (
        <div className={`${classes} ${className || ''}`} />
    );
};

export default Divider;
